export class PcpSettings {
  linkback_url?: any;
  receive_endpoint?: string;
  submit_endpoint?: string;
  submit_deselect_route?: string;
  submit_deselect_params?: any;
  submit_params?: any;
  submit_type?: any;
  pcp_id?: string;
  pcp_identifier?: string;
  only_scrape_get_params?: string[];
  showHomepageMessage?: boolean;

  constructor(obj?: any, env: string = '') {
    if (obj) {
      this.linkback_url = setLinkbackUrl(obj.linkback_url, env);
      this.receive_endpoint = obj.receive_endpoint || '';
      this.submit_endpoint = obj.submit_endpoint || '';
      this.submit_deselect_route = obj.submit_deselect_route || '';
      this.submit_deselect_params = obj.submit_deselect_params || null;
      this.submit_params = obj.submit_params || null;
      this.submit_type = obj.submit_type || null;
      this.pcp_id = obj.pcp_id || null;
      this.pcp_identifier = obj.pcp_identifier || null;
      this.only_scrape_get_params = obj.only_scrape_get_params || [];
      this.showHomepageMessage = obj.showHomepageMessage === 'true' || false;
    }
  }
}

const setLinkbackUrl = (linkback_url: any, env: string) => {
  if (linkback_url !== null && typeof linkback_url === 'object') {
    return (
      linkback_url[env] ||
      linkback_url[env.toLowerCase()] ||
      linkback_url.default ||
      ''
    );
  }

  return linkback_url || '';
};
